module.exports = __webpack_public_path__ + "zvetseni-prsou_22_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_22_after.jpg
// module id = 1315
// module chunks = 0